import { render } from "./MarketPlaceLoginModal.vue?vue&type=template&id=b5e793e4"
import script from "./MarketPlaceLoginModal.vue?vue&type=script&lang=js"
export * from "./MarketPlaceLoginModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/richken/code/StoryPhonesWebsite/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__